/* eslint-disable import/prefer-default-export */

export const reload = (browserWindow = window) => {
    browserWindow.location.reload();
};

export const getCurrentYear = () => {
    return new Date().getFullYear();
};
